module.exports = __webpack_public_path__ + "static/media/hounds.a6a55c43.png";